import { render, staticRenderFns } from "./QuizOption.vue?vue&type=template&id=67269a7c&scoped=true&"
import script from "./QuizOption.vue?vue&type=script&lang=js&"
export * from "./QuizOption.vue?vue&type=script&lang=js&"
import style0 from "./QuizOption.vue?vue&type=style&index=0&id=67269a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67269a7c",
  null
  
)

export default component.exports